import { Controller } from "@hotwired/stimulus"

// Pushes a plain Google Ads conversion event to the GTM dataLayer when the host
// element connects. Unlike enhanced-conversion, it carries no user data and no
// value — used for value-less lead conversions (e.g. the free daycare trial
// form's thank-you page).
//
// The Rails partial only renders the host element in production, so non-prod
// never fires. GTM-side wiring (custom-event trigger + Ads conversion tag) is
// owned by the GTM container config, not this controller.
export default class extends Controller {
  static values = { payload: Object }

  connect() {
    if (!this.hasPayloadValue) return
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(this.payloadValue)
  }
}
